import { createContext } from "react"

const Header = createContext()

export default Header
